import React, {Component} from 'react';
import bbox from '@turf/bbox'
import {lineString} from '@turf/helpers'

import MapGL, {Marker, NavigationControl, Popup} from '@urbica/react-map-gl'
import Cluster from '@urbica/react-map-gl-cluster'
import ClusterMarker from "./ClusterMarker.js";
import 'mapbox-gl/dist/mapbox-gl.css'
import VCMarker from "./assets/Marker.png";
import ApartmentPopup from "./ApartmentPopup";

export default class extends Component {
    state = {
        zoom: 6,
        popup: null,
    }
    mapRef = React.createRef();

    onMapClick = (event) => {
        const isMarker = event.originalEvent.target instanceof HTMLImageElement
        if (!isMarker) return
        
        const {lngLat} = event
        let currentZoom = this.mapRef.current.props.zoom

        this.setState({
            latitude: lngLat.lat,
            longitude: lngLat.lng,
            zoom: ++currentZoom,
        });
    }

    onMarkerClick = (e, point) => {
        e.stopPropagation()

        this.setState({
            popup: point
        })
    }

    onPopupClose = () => {
        this.setState({
            popup: null
        })
    }

    getBounds = () => {
        const {points} = this.props
        if (points.length < 2) return null

        const pointsCoordinates = points.map(point =>
            [parseFloat(point.coordinates.lng), parseFloat(point.coordinates.lat)]
        )

        const line = lineString([...pointsCoordinates]);
        const bounds = bbox(line)
        const paddingTopBottom = 4.5
        const paddingLeftRight = 2

        return [
            bounds[0] -= paddingLeftRight,
            bounds[1] += paddingTopBottom,
            bounds[2] += paddingLeftRight,
            bounds[3] -= paddingTopBottom
        ]
    }

    getDefaultCoordinates = () => {
        const latLng = this.props.points[0].coordinates

        return {
            latitude: parseFloat(latLng.lat),
            longitude: parseFloat(latLng.lng),
        }
    }

    render() {
        const {points} = this.props
        const defaultCoordinates = points.length ? this.getDefaultCoordinates() : null

        return <div id="apartments-map" className="search-filters__map search-filters__map--clustered">
            <div className='wrapper-apartment-box'>
                {points.length ?
                    <MapGL
                        {...defaultCoordinates}
                        {...this.state}
                        ref={this.mapRef}
                        style={{width: '100%', height: '400px'}}
                        mapStyle="mapbox://styles/mapbox/light-v9"
                        bounds={this.getBounds()}
                        accessToken={process.env.MIX_MAPBOX_ACCESS_TOKEN}
                        onClick={this.onMapClick}
                        onViewportChange={nextViewport => this.setState(nextViewport)}
                        viewportChangeMethod='flyTo'
                        viewportChangeOptions={{duration: 1000}}
                    >
                        {this.state.popup &&
                        <Popup
                            longitude={this.state.popup.coordinates.lng}
                            latitude={this.state.popup.coordinates.lat}
                            closeButton={false}
                            closeOnClick={false}
                            offset={30}
                        >
                            <ApartmentPopup
                                point={this.state.popup}
                                onClose={this.onPopupClose}
                            />
                        </Popup>
                        }
                        <Cluster radius={40} extent={512} nodeSize={24} component={ClusterMarker}>
                            {points.map((point) => (
                                <Marker
                                    key={point.id}
                                    longitude={point.coordinates.lng}
                                    latitude={point.coordinates.lat}
                                    onClick={e => this.onMarkerClick(e, point)}
                                    offset={[0, -50]}
                                >
                                    <img
                                        src={VCMarker}
                                        alt="Marker VC"
                                        style={{height: '55px', cursor: 'pointer'}}
                                    />
                                </Marker>
                            ))}
                        </Cluster>
                        <NavigationControl showZoom position="bottom-right"/>
                    </MapGL>
                    : null
                }
            </div>
        </div>
    }
}
